import { render, staticRenderFns } from "./OnboardingCameraLayout.vue?vue&type=template&id=5b329dd8&scoped=true"
import script from "./OnboardingCameraLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingCameraLayout.vue?vue&type=script&lang=js"
import style0 from "./OnboardingCameraLayout.vue?vue&type=style&index=0&id=5b329dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b329dd8",
  null
  
)

export default component.exports